import React from "react";
import { Carousel } from "react-bootstrap";
import { imgUrlConverter } from '../../util';

const ProductCarousel = ({ data }) => {

  return (
    <Carousel className="product-detail-wrapper" controls={false} indicators={data?.length > 1 ? true : false} indicatorlabels={[]} interval={null} >
    {
      data?.map((altImage, key) =>
        <Carousel.Item key={altImage?.altImageDisplayName+key}>
          <picture>
            <source media="(min-width: 1920px)" srcSet={imgUrlConverter(altImage?.altImageUrl)} />
            <img src={imgUrlConverter(altImage?.altImageUrl)} alt={altImage?.altImageDisplayName} />
          </picture>
        </Carousel.Item>
      )
    }
  </Carousel>
  );
};

export default ProductCarousel;
